'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const VaultV2ExposureError = () => {
  return <ErrorDataUnavailable minHeight="320px" />
}

export default memo(VaultV2ExposureError)
